// extracted by mini-css-extract-plugin
module.exports = {"legend":"ClientOrientations_legend__3rjO2","title":"ClientOrientations_title__FUng8","items":"ClientOrientations_items__2XO4S","footer":"ClientOrientations_footer__38VWF"};